'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.yearsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/yearsFromNow.js
// module id = 300
// module chunks = 1